import type { DocumentData } from "firebase/firestore";
import BaseApi from "../core/BaseApi";
import SuperUserModel, { type SuperUserModelData } from "./SuperUserModel";

export default class SuperUsersApi extends BaseApi<
  SuperUserModel,
  SuperUserModelData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}super_users`;
  }

  get store() {
    return this.stores.superUsersStore;
  }

  fromFirestore(res: DocumentData): SuperUserModel {
    return new SuperUserModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
